import styled from "styled-components";
import { IntroductionSectionProps } from "./props";

export const IntroductionSectionContainer = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding: 72px 24px 104px;
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  column-gap: 72px;
  align-items: start;
  @media (max-width: 768px) {
    display: block;
    max-width: 320px;
    padding: 40px 0px 80px;
  }
`;

export const IntroductionSticky = styled.aside`
  position: sticky;
  top: 104px;
  align-self: start;
  @media (max-width: 768px) {
    position: static;
  }
`;

export const IntroductionContent = styled.div`
  min-width: 0;
`;

export const IntroductionProfile = styled.section`
  padding-bottom: 48px;
  border-bottom: 1px solid var(--line);
`;

export const IntroductionIllustration = styled.img`
  width: 280px;
  height: 330px;
  object-fit: cover;
  object-position: center;
  filter: var(--illustration-filter);
  transition: filter 0.24s ease;
  @media (max-width: 768px) {
    display: block;
    width: 240px;
    height: 270px;
    margin: 0 auto;
  }
`;

export const IntroductionIllustrationDetail = styled.div`
  font-size: 18px;
  line-height: 30px;
  letter-spacing: normal;
  text-align: left;
  @media (max-width: 768px) {
    font-size: 17px;
    margin: 0px;
    line-height: 24px;
    letter-spacing: normal;
    font-weight: normal;
  }
`;

export const TextUnderline = styled.button`
  padding: 0px;
  border: none;
  color: inherit;
  background: transparent;
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
`;

export const SocialMediaIconGroup = styled.div``;

export const SocialMediaIcon = styled.img<IntroductionSectionProps>`
  margin-left: ${({ margin }) => margin?.left || 16}px;
  margin-right: ${({ margin }) => margin?.right || 16}px;
  margin-top: 24px;
  margin-bottom: 24px;
  width: 48px;
  filter: var(--social-icon-filter);
  transition: filter 0.24s ease;
  @media (max-width: 768px) {
    margin: 24px 0px;
    margin-right: 12px;
  }
`;

export const CurrentRead = styled.aside`
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  gap: 28px;
  align-items: center;
  margin-top: 12px;
  @media (max-width: 768px) {
    max-width: 220px;
    gap: 20px;
    margin: 12px auto 48px;
  }
`;

export const CurrentReadCover = styled.img`
  width: 56px;
  height: 84px;
  display: block;
  margin: 0px;
  border-radius: 3px 7px 7px 3px;
  object-fit: cover;
  box-shadow: 5px 7px 16px rgba(34, 34, 34, 0.16);
  transform: rotate(1.5deg);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  ${CurrentRead}:hover & {
    transform: rotate(0deg) translateY(-2px);
    box-shadow: 7px 10px 20px rgba(34, 34, 34, 0.2);
  }
  @media (max-width: 768px) {
    width: 56px;
    height: 84px;
    margin: 0px;
  }
`;

export const CurrentReadLabel = styled.span`
  display: block;
  margin-bottom: 6px;
  color: var(--muted);
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const CurrentReadLink = styled.a`
  display: inline-block;
  color: var(--text);
  font-family: "Literata", Georgia, serif;
  font-size: 15px;
  line-height: 20px;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

export const CurrentReadAuthor = styled.span`
  display: block;
  margin-top: 5px;
  color: var(--muted);
  font-size: 12px;
`;
